import { Modal } from '@modusign/design-system';

import noop from '@libs/noop';

interface ResourceModalProps {
  children: React.ReactNode;
  isOpen: boolean;
  maxWidth?: number | string;
  onRequestClose?: () => void;
}

function ResourceModal({ children, isOpen, maxWidth = 'sm', onRequestClose }: ResourceModalProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      borderRadius="3px"
      isOpen={isOpen}
      maxWidth={maxWidth}
      px={0}
      py={0}
      onClose={onRequestClose ?? noop}
      onRequestClose={onRequestClose}
    >
      {children}
    </Modal>
  );
}

export default ResourceModal;
